/*  ==========================================================================
    SLICK CAROUSEL
    Helper functions to create different sliders.

    INFO:
    - needs "slick-carousel"
    - the option "dynamicHeight" is custom and not a original from slick
    - "dynamicHeight" needs "mresize"
    - the option "equalHeight" is custom and not a original from slick
    - "equalHeight" works only on a plural slider and if "adaptiveHeight" is
      deactivated
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'lodash/lodash.js';
import 'mresize';
import 'slick-carousel';

// local imports
import * as vars from '../../globals/variables';
import * as utils from "../utils";

/*
 * SINGLE SLIDER
 */

export function initSingleSlider($element,overrides) {
    let $arrows = $element.parent().find('.slick-arrows'),
        $dots = $element.parent().find('.slick-dots');

    // default options
    let defaults = {
            adaptiveHeight: false,
            appendArrows: $arrows,
            appendDots: $dots,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 6000,
            dots: true,
            draggable: true,
            dynamicHeight: false,
            fade: true,
            infinite: true,
            nextArrow: vars.slick_nextArrow,
            pauseOnHover: false,
            prevArrow: vars.slick_prevArrow,
            speed: 1000,
            swipe: true,
            touchMove: true
        };

    // options overrides
    let options = $.extend({}, defaults, overrides);

    // trigger slider if more then one image are given
    if ($element.children().length > 1) {
        $element.slick(options);

        // trigger slide to refresh on window resize
        $(window).on('resize', _.debounce(function () {
            $element.slick('slickNext');
        }, 250));

        // dynamic slider height, useful if content inside "slick-slide" gets loaded dynamically (only activated if the custom option "dynamicHeight" is "true" and the "adaptiveHeight" option is "true"!)
        if (options.dynamicHeight === true && options.adaptiveHeight === true) {
            function resizeCurrentSlide() {
                let $currentSlide = $element.find('> .slick-list > .slick-track > .slick-slide.slick-current');
                $currentSlide.on('mresize', _.debounce(function () {
                    $element.find('> .slick-list').css('height', $currentSlide.height() + 'px');
                }, 250));
            }
            $element.on('init', resizeCurrentSlide);
            $element.on('afterChange', resizeCurrentSlide);
        }

    }

}

/*
 * PLURAL SLIDER
 */

export function initPluralSlider($element,overrides) {
    let $arrows = $element.parent().find('.slick-arrows'),
        $dots = $element.parent().find('.slick-dots');

    // default options
    let defaults = {
        adaptiveHeight: false,
        appendArrows: $arrows,
        appendDots: $dots,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 6000,
        dots: true,
        draggable: true,
        equalHeight: false,
        fade: false,
        infinite: true,
        nextArrow: vars.slick_nextArrow,
        pauseOnHover: false,
        prevArrow: vars.slick_prevArrow,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 481,
                settings: {
                    slidesToShow: 1
                }
            }
        ],
        slidesToScroll: 1,
        slidesToShow: 3,
        speed: 1000,
        swipe: true,
        touchMove: false
    };

    // options overrides
    let options = $.extend({}, defaults, overrides);

    // trigger slider if more then slides to show are given
    if ($element.children().length > options.slidesToShow) {
        $element.slick(options);

        // trigger slide to refresh on window resize
        $(window).on('resize', _.debounce(function () {
            $element.slick('slickNext');
        }, 250));

        // equal items height (only activated if the custom option "equalHeight" is "true" and the "adaptiveHeight" option is "false"!)
        if (options.equalHeight === true && options.adaptiveHeight === false) {
            $element.on('setPosition', _.debounce(function (event, slick) {
                $element.find('> .slick-list > .slick-track > .slick-slide').css('height', $element.find('> .slick-list > .slick-track').height() + 'px');
            }, 500));
        }

    }

}


// WEBPACK FOOTER //
// ./source/js/utilities/lib/slick-carousel.js